import { ClearBlade } from 'clearblade-js-client';
import 'clearblade-js-client/lib/mqttws31';

export const cb = new ClearBlade();
